(function() {
    'use strict';

    angular
        .module('etrrbApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','GLOBAL_URL'];

    function stateConfig($stateProvider,GLOBAL_URL) {
        $stateProvider.state('etrrb', {
            url: '/etrrb',
            data: {
                pageTitle: 'THU PHÍ ĐIỆN TỬ'
            },
            views: {
                'content@': {
                    templateUrl: GLOBAL_URL+'partial?uri=ga/etrrb/etrrb',
                    controller: 'ETrrbController',
                    controllerAs: 'etrrbCtr'
                }
            }
        })
        .state('etrrb-cancel', {
            url: '/etrrb-cancel',
            data: {
                pageTitle: 'HỦY GIAO DỊCH CẤP PHÁT PHIẾU THU ĐIỆN TỬ'
            },
            views: {
                'content@': {
                    templateUrl: GLOBAL_URL+'partial?uri=ga/etrrb/etrrb-cancel',
                    controller: 'ETrrbController',
                    controllerAs: 'etrrbCtr'
                }
            }
        })
        .state('etrrb-violation', {
            url: '/etrrb-violation',
            data: {
                pageTitle: 'QUẢN LÝ VI PHẠM CHẬM NỘP PHÍ'
            },
            views: {
                'content@': {
                    templateUrl: GLOBAL_URL+'partial?uri=ga/etrrb/etrrb-violation',
                    controller: 'ETrrbController',
                    controllerAs: 'etrrbCtr'
                }
            }
        })
    }
})();
